<template>
  <main :data-wio-id="pageId" :key="pageId">
    <NotFound v-if="page && page === '404'" />
    <template v-else-if="page">
      <template v-for="(section, i) in page.body">
        <Hero
          v-if="section.slice_type === 'hero'"
          :key="`${section.slice_type}-${i}`"
          :hero="section"
        />
        <Article
          v-else-if="section.slice_type === 'article'"
          :key="`${section.slice_type}-${i}`"
          :article="section.primary"
          :class="{
            'last-article':
              page.body[i + 1] && page.body[i + 1].slice_type !== 'article'
          }"
        />
        <CallToAction
          v-else-if="section.slice_type === 'call_to_action'"
          :key="`${section.slice_type}-${i}`"
          :article="section"
          class="cta"
        />
        <Features
          v-else-if="section.slice_type === 'features'"
          :key="`${section.slice_type}-${i}`"
          :features="section"
        />
        <Quotes
          v-else-if="section.slice_type === 'quote'"
          :key="`${section.slice_type}-${i}`"
          :quotes="section"
        />
        <LegalBlock
          v-else-if="section.slice_type === 'legal_block'"
          :key="`${section.slice_type}-${i}`"
          :policy="section"
        />
        <FAQs
          v-else-if="section.slice_type === 'faqs'"
          :key="`${section.slice_type}-${i}`"
          :faqs="section"
        />
      </template>
    </template>

    <div v-else class="content-min-height">
      <Spinner class="margin-top-lg" />
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import Hero from '@/components/Hero';
import Button from '@/components/Button';
import Article from '@/components/Article';
import CallToAction from '@/components/CallToAction';
import Spinner from '@/components/Spinner';
import Features from '@/components/Features';
import Quotes from '@/components/Quotes';
import NotFound from '@/components/NotFound';
import LegalBlock from '@/components/LegalBlock';
import FAQs from '@/components/FAQs';

export default {
  components: {
    Hero,
    Button,
    Article,
    CallToAction,
    Spinner,
    Features,
    Quotes,
    NotFound,
    LegalBlock,
    FAQs
  },
  metaInfo() {
    return {
      title: this.page && this.page.page_title
    };
  },
  computed: {
    ...mapState(['pages']),
    page() {
      if (!this.pages.length) {
        return;
      }
      const page = this.pages.find(
        ({ data }) =>
          this.$route.path === data.path || this.$route.path === `${data.path}/`
      );

      if (!page) {
        return '404';
      }

      return page.data;
    },
    pageId() {
      if (!this.pages.length) {
        return;
      }
      const page = this.pages.find(
        ({ data }) =>
          this.$route.path === data.path || this.$route.path === `${data.path}/`
      );

      return page ? page.id : '404';
    },
    blockSlices() {
      if (!this.page) {
        return;
      }
      return this.page.body.filter(block => {
        return (
          block.slice_type === 'solution_block' ||
          block.slice_type === 'three_article_block'
        );
      });
    }
  },
  watch: {
    pageId() {
      if (window && window.PrismicToolbar) {
        window.PrismicToolbar.setupEditButton();
      }
    },
    pages(newPages, oldPages) {
      // Refetch pages when language changed
      if (oldPages.length && !newPages.length) {
        this.$store.dispatch('getPages');
      }
    }
  },
  serverPrefetch() {
    return this.$store.dispatch('getPages');
  },
  mounted() {
    if (!this.pages.length) {
      this.$store.dispatch('getPages', this.$route.path);
    }
    if (window && window.PrismicToolbar) {
      window.PrismicToolbar.setupEditButton();
    }
  }
};
</script>
